export default {
    Metadata: {
        Name: "GetSecond",
        Description: "Returns the second from a given date.",
        Syntax: "GetSecond(date)",
        Keywords: ['Date', 'Time'],
        Author: "DataVoke, Inc.",
    },
    execute(fromDate) {
        fromDate = app.dv.helpers.exprEng.expr.todate(fromDate);
        if (fromDate != null) {
            return fromDate.getSeconds();
        }
        else {
            return null;
        }
    },
};

